import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { __ } from '@wordpress/i18n';
import { Component, createRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import Dashicon from '../dashicon';
import { DropZoneConsumer } from './provider';

var DropZone = function DropZone(props) {
  return createElement(DropZoneConsumer, null, function (_ref) {
    var addDropZone = _ref.addDropZone,
        removeDropZone = _ref.removeDropZone;
    return createElement(DropZoneComponent, _extends({
      addDropZone: addDropZone,
      removeDropZone: removeDropZone
    }, props));
  });
};

var DropZoneComponent =
/*#__PURE__*/
function (_Component) {
  _inherits(DropZoneComponent, _Component);

  function DropZoneComponent() {
    var _this;

    _classCallCheck(this, DropZoneComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropZoneComponent).apply(this, arguments));
    _this.dropZoneElement = createRef();
    _this.dropZone = {
      element: null,
      onDrop: _this.props.onDrop,
      onFilesDrop: _this.props.onFilesDrop,
      onHTMLDrop: _this.props.onHTMLDrop,
      setState: _this.setState.bind(_assertThisInitialized(_this))
    };
    _this.state = {
      isDraggingOverDocument: false,
      isDraggingOverElement: false,
      position: null,
      type: null
    };
    return _this;
  }

  _createClass(DropZoneComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Set element after the component has a node assigned in the DOM
      this.dropZone.element = this.dropZoneElement.current;
      this.props.addDropZone(this.dropZone);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.removeDropZone(this.dropZone);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          label = _this$props.label;
      var _this$state = this.state,
          isDraggingOverDocument = _this$state.isDraggingOverDocument,
          isDraggingOverElement = _this$state.isDraggingOverElement,
          position = _this$state.position,
          type = _this$state.type;
      var classes = classnames('components-drop-zone', className, _defineProperty({
        'is-active': isDraggingOverDocument || isDraggingOverElement,
        'is-dragging-over-document': isDraggingOverDocument,
        'is-dragging-over-element': isDraggingOverElement,
        'is-close-to-top': position && position.y === 'top',
        'is-close-to-bottom': position && position.y === 'bottom',
        'is-close-to-left': position && position.x === 'left',
        'is-close-to-right': position && position.x === 'right'
      }, "is-dragging-".concat(type), !!type));
      var children;

      if (isDraggingOverElement) {
        children = createElement("div", {
          className: "components-drop-zone__content"
        }, createElement(Dashicon, {
          icon: "upload",
          size: "40",
          className: "components-drop-zone__content-icon"
        }), createElement("span", {
          className: "components-drop-zone__content-text"
        }, label ? label : __('Drop files to upload')));
      }

      return createElement("div", {
        ref: this.dropZoneElement,
        className: classes
      }, children);
    }
  }]);

  return DropZoneComponent;
}(Component);

export default DropZone;
//# sourceMappingURL=index.js.map